//Delivery Options
const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

      function addDaysToDate(date, days) {
        // Create a new Date object to avoid modifying the original date
        let newDate = new Date(date);
        // Add the specified number of days
        newDate.setDate(newDate.getDate() + days);
        return newDate;
      }

      function getNext(start, delday, cntr = 0) {
        // Get the current day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
        let dayOfWeek = start.getDay();

       // console.log("getNext " + start + " " + dayOfWeek + " " + delday);
        //is this the day we want
        if (delday == dayOfWeek && cntr > 0) {
          return start;
        }
        cntr++;
        return getNext(addDaysToDate(start, 1), delday, cntr); //recursion
      }


    function builddeliverypicker() {
      const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"];
      
      const date = new Date(); // Current date
      const dayIndex = date.getDay();
      let dayCode = daysOfWeek[dayIndex];
      let options;
      let dateobj = [];

      

      //Handle cut off for ordering
      // 24 Sept 2026: Sunday and Wednesday cut-offs moved from 19:00 to 18:00. After those cut-offs the dates are
      // worked out from the next day (Wednesday used to become "Thu", which matched no option, so no dates showed).
      // Saturday is left at 19:00 as before.
      let hours = date.getHours();
      let dayShift = 0;
      if (hours >= 18 && dayCode == "Wed") {
        dayCode = "Thur";
        dayShift = 1;
      } else if (hours >= 18 && dayCode == "Sun") {
        dayCode = "Mon";
        dayShift = 1;
      } else if (hours >= 19 && dayCode == "Sat") {
        dayCode = "Sun";
      }

      switch (dayCode) {
        case "Sat":
          options = ["Sun", "Sun-Thur", "Mon", "Mon-Thur"];
          break;
        case "Sun":
          options = ["Mon", "Mon-Thur", "Thur", "Sun"];
          break;
        case "Mon":
          options = ["Thur", "Thur-Sun", "Thur-Mon", "Sun"];
          break;
        case "Tue":
          options = ["Thur", "Thur-Sun", "Thur-Mon", "Sun"];
          break;
        case "Wed":
          options = ["Thur", "Thur-Sun", "Thur-Mon", "Sun"];
          break;
        case "Thur":
          options = ["Sun", "Sun-Thur", "Mon", "Mon-Thur", "Thur"];
          break;
        case "Fri":
          options = ["Sun", "Sun-Thur", "Mon", "Mon-Thur", "Thur"];
          break;
        default:
          options = []; // Default case if none of the above match
      }

      console.log(options);
      var postageoptions = [];
      var htmloutput = "";
      var init = 0;
      if (options.length > 0) {
        for (i = 0; i <= options.length-1; i++) {
          var sel = (init == 0 ? " checked='checked' " : '');
          init = 1;
          let start = addDaysToDate(new Date(), dayShift);
          var da = options[i];
        
          if (da.includes("-")) {
            var daa = da.split("-");
            var splitday = [];
            var htmlo = [];
            for (x = 0; x < daa.length; x++) {
              let delday = daysOfWeek.indexOf(daa[x]);
              var dateoption = getNext(start, delday);
              const monthIndex = dateoption.getMonth()
              const day = String(dateoption.getDate()).padStart(2, '0');
              datestr = daa[x] + ", " + day + " " + monthNames[monthIndex];
              htmlo.push(datestr);
              splitday[daa[x]] = dateoption;
            }
          
            datestr =  htmlo.join(" | ");
            htmloutput += '<input type="radio" name="date-option" '+ sel +' value="'+datestr+'">'+datestr + '<br />';
            //add the options to the main array
            postageoptions[da] = splitday;
          } else {
            //Single Day option
            let delday = daysOfWeek.indexOf(da);
            var dateoption = getNext(start, delday);
            const monthIndex = dateoption.getMonth()
            const day = String(dateoption.getDate()).padStart(2, '0');
            datestr = da + ", " + day + " " + monthNames[monthIndex];
            
            htmloutput += '<label><input type="radio" name="date-option"  '+ sel +'  value="'+datestr+'">'+datestr + '</label><br />';
           
            postageoptions[da] = dateoption;
          }
        }
      }

     $("#deliveryoptions").html(htmloutput);
    }
//End Date Picker











// Constants for initial loop values
const INITIAL_MEAL_LOOP = 3;
const INITIAL_SNACK_LOOP = 1;

let ml = INITIAL_MEAL_LOOP;
let sl = INITIAL_SNACK_LOOP;
let gcl = 0;

async function pmca(mealtitle, selectedcarb, selectedveg, packagename) {
    return new Promise((resolve, reject) => {
        $.post("https://macrobasedmeals.co.uk/get_macros.php", {
            name: mealtitle,
            carb: selectedcarb,
            veg: selectedveg,
            packagename: packagename
        }, function(data) {
            try {
                var macrodata = JSON.parse(data);
                var cals = macrodata.cals;
                var prot = macrodata.prot;
                var carb = macrodata.carb;
                var fat = macrodata.fat;
                var allergens = macrodata.allergens;

                var macros = "<img src='//macrobaseddiner.co.uk/cdn/shop/t/15/assets/calories.png?v=106732640345358007901659273377' alt='' class='h-4 mr-1'><b class='mx-1'>" + cals + "</b> Calories";
                macros += " | <img src='//macrobaseddiner.co.uk/cdn/shop/t/15/assets/carbs.png?v=16803319092747802061659273377' alt='' class='h-4 mr-1'> <b class='mx-1'>" + carb + "g</b> Carbs";
                macros += " | <img src='//macrobaseddiner.co.uk/cdn/shop/t/15/assets/protein.png?v=173283622244016477321659273377' alt='' class='h-4 mr-1'>       <b class='mx-1'>" + prot + "g</b> Protein";
                macros += " | <img src='//macrobaseddiner.co.uk/cdn/shop/t/15/assets/fats.png?v=50881559055355347311659273377' alt='' class='h-4 mr-1'> <b class='mx-1'>" + fat + "g</b> Fat";

                resolve([macros, allergens, cals]);
            } catch (error) {
                reject(error);
            }
        }).fail(error => {
            reject(error);
        });
    });
}

async function pmcb(opt) {
    return new Promise((resolve, reject) => {
        $.post("https://macrobasedmeals.co.uk/get_sundries.php", {
            name: opt,
        }, function(data) {
            try {
                var macrodata = JSON.parse(data);
                var cals = macrodata.cal;
                var prot = macrodata.prot;
                var carb = macrodata.carbs;
                var fat = macrodata.fat;
                var allergens = macrodata.allergies;

                var macros = "";
                console.log(cals)
                if ( macrodata != false ) {
                  macros = "<img src='//macrobaseddiner.co.uk/cdn/shop/t/15/assets/calories.png?v=106732640345358007901659273377' alt='' class='h-4 mr-1'><b class='mx-1'>" + cals + "</b> Calories";
                  macros += " | <img src='//macrobaseddiner.co.uk/cdn/shop/t/15/assets/carbs.png?v=16803319092747802061659273377' alt='' class='h-4 mr-1'> <b class='mx-1'>" + carb + "g</b> Carbs";
                  macros += " | <img src='//macrobaseddiner.co.uk/cdn/shop/t/15/assets/protein.png?v=173283622244016477321659273377' alt='' class='h-4 mr-1'>       <b class='mx-1'>" + prot + "g</b> Protein";
                  macros += " | <img src='//macrobaseddiner.co.uk/cdn/shop/t/15/assets/fats.png?v=50881559055355347311659273377' alt='' class='h-4 mr-1'> <b class='mx-1'>" + fat + "g</b> Fat";
                }
                resolve([macros, cals]);
            } catch (error) {
                reject(error);
            }
        }).fail(error => {
            reject(error);
        });
    });
}


function productselector(product_id, variant_id, calories) {

    $("#caltitle").text(`${calories} calorie`);

  gcl = calories;
 // Update snack loop based on calories
  if (calories === 2000 || calories === 2500) {
    sl = 2;
  }

  // Update meal loop based on calories
  if (calories === 3000) {
    ml = 4;
  }
  
  $("#variant_id").val(variant_id);
  $("#product_id").val(product_id);
  $("#productlist").fadeOut();
  $("#comp-pack-s2").fadeIn();

  buildmeals(ml, sl);
}

function buildmeals(ml, sl) {
  
  let baseprot = $("#protbase");
  let basecarb = $("#base-carb");
  let baseveg = $("#base-veg");
  let basebreakfast = $("#breakfast");
  let basesnack = $("#snacks");
  
  for (let d=1; d <= 5; d++) {
       $("#completepackagedaybuilder").append("<div id='cmb-day"+d+"' class='cmbtab' style='display:none;'></div>");
       $("#cmb-day"+d).append("<h2>Day "+d+"</h2>");

      //Breakfast
       var b = basebreakfast.clone().prop('id', 'breakfast-day-'+d );
      
      
       $("#cmb-day"+d).append("<h2>Breakfast:</h2>");
       $("#cmb-day"+d).append(b);
      
      //Build main meals
      for (let i=1; i <= ml; i++) {        
        var p = baseprot.clone().prop('id', 'prot-meal'+i+'-day-'+d );
        var c = basecarb.clone().prop('id', 'carb-meal'+i+'-day-'+d );
        var v = baseveg.clone().prop('id', 'veg-meal'+i+'-day-'+d );
      
        //Build Day Picker UI
        $("#cmb-day"+d).append("<h2>Meal "+i+":</h2>");
        $("#cmb-day"+d).append(p);
        $("#cmb-day"+d).append(c);
        $("#cmb-day"+d).append(v);
      }

      //Add snacks
      $("#cmb-day"+d).append("<h2>Snacks:</h2>");
      for (let q=1; q <= sl; q++) { 
        var s = basesnack.clone().prop('id', 'snack-day-'+d+'-c-'+q);
        $("#cmb-day"+d).append(s);
      }
      
    }
}

$.extend({
    getQueryString: function(name) {
        var url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
});

$(document).ready(function() {
  builddeliverypicker();
  $("#deliveryoption").on("change", function() {
    delval = $(this).val();
   // $("#deliveryoptions").html("");
    if (delval == "National Delivery") {
      let start = new Date();
      let delday = 3;
      var dateoption = getNext(start, delday);

      // 24 Sept 2026: DPD delivers on the Wednesday after an order placed by 18:00 on the Sunday before.
      // (Was: moved on a week only from Tuesday 19:00, and skipped a whole week when ordering on a Wednesday.)
      var nationalCutoff = addDaysToDate(dateoption, -3);
      nationalCutoff.setHours(18, 0, 0, 0);
      if (start >= nationalCutoff) {
       dateoption =  addDaysToDate(dateoption, 7);
      }
      
      const monthIndex = dateoption.getMonth()
      const day = String(dateoption.getDate()).padStart(2, '0');
      datestr = "Wed, " + day + " " + monthNames[monthIndex];   
      htmloutput = '<label><input type="radio" name="date-option"  checked="checked"  value="'+datestr+'">'+datestr + '</label><br />';
      $("#deliveryoptions").html(htmloutput);
    } else {
      builddeliverypicker();
    }
    
  })

  $(".daytab").on("click", function(){
    $( ".daytab" ).removeClass( "active" );
    $(this).addClass( "active" );
    $("#cmbgetstarted").fadeOut();
    $(".cmbtab").fadeOut();
    var dayid = $(this).attr("id");
    $("#cmb-"+dayid).fadeIn();

    $("#completepackagedaybuilder").fadeIn();
    $("#completepackagedayreview").fadeOut();
    $("#cmb-add-to-cart").fadeOut();
    $("#revieworder").fadeIn();
  });

    var packagepicker = $.getQueryString('c');
console.log(packagepicker)
    if (packagepicker != null) {
      $("#recommendedpack").fadeIn();
      $(".mbdpackage").fadeOut();
      $("#"+packagepicker).fadeIn();
    }
  
});

function caloriespackagemapper(cals) {

  switch (cals) {
    case 1500:
      return "Weight Loss";
    case 1800:
    case 2000:
      return "Maintenance";
    default:
      return "Weight Gain";
  }
}

async function revieworder() {
    let output = "";
    let packagecals = 0;
    for (let d = 1; d <= 5; d++) {
        dailycals = 0;
        output += "<h2><b>Day " + d + "</b></h2>";
        let dailymeal = "";
         
        const resultb = await pmcb($('#breakfast-day-' + d).val());
        let [macros, cals] = resultb;
        dailycals += (typeof cals === 'number' && !isNaN(cals)) ? cals : 0;
      console.log("Daily Cals: "+ dailycals + " and Cals: " + cals);
        output += "<p>Breakfast: " + $('#breakfast-day-' + d).val() + " " + macros + "</p>";
        dailymeal = "Breakfast: " + $('#breakfast-day-' + d).val() + " , ";
       
      
        for (let i = 1; i <= ml; i++) {
            let p = $("#prot-meal" + i + "-day-" + d + " option:selected").text();
            let c = $("#carb-meal" + i + "-day-" + d).val();
            let v = $("#veg-meal" + i + "-day-" + d).val();

            // Calorie and Allergen Lookup
            try {
              const package = caloriespackagemapper(gcl);
              const result = await pmca(p.trim(), c.trim(), v.trim(), package);
              
              let [macros, allergens, cals] = result;
              dailycals += (typeof cals === 'number' && !isNaN(cals)) ? cals : 0;
              console.log("Daily Cals: "+ dailycals + " and Cals: " + cals);
              macroid = "macro-"+d+"-"+i;
              output += "<p>Meal " + i + ": " + p + " | " + c + " | " + v + " | " + macros + "</p>";
              dailymeal += "Meal " + i + ": " + p + " | " + c + " | " + v + ", ";
               
            } catch (error) {
                console.error('Error fetching macros:', error);
            }
        }

        for (let q = 1; q <= sl; q++) {
          
          if ($('#snack-day-' + d + '-c-' + q).length) {
            const resultc = await pmcb($('#snack-day-' + d + '-c-' + q).val());
            let [macros, cals] = resultc;
           dailycals += (typeof cals === 'number' && !isNaN(cals)) ? cals : 0;
            console.log("Daily Cals: "+ dailycals + " and Cals: " + cals);
            output += "<p>Snacks: " + $('#snack-day-' + d + '-c-' + q).val() + " " + macros + "</p>";
            dailymeal += (q > 1 ? " | " : "");
            dailymeal += (q == 1 ? "Snacks: " : "");
            dailymeal +=$('#snack-day-' + d + '-c-' + q).val();
          }
        }
        packagecals += dailycals;
        output += "<p><b>Your daily calories based on your meal selections are: "+dailycals+" calories</b></p>";
      console.log("The daily cals is: " + dailycals);
        $("#cpd" + d).val(dailymeal);
    }

    output += "<p><b>Your Complete Meal Package calories based on your meal selections are: "+packagecals+" calories</b></p>";

    const selectedOption = $('input[name="date-option"]:checked').val();
    const selectedDelType = $("#deliveryoption").val(); 
    output = "<h2>Your Delivery Options</h2>" + "<p><b>Delivery Date(s):</b> " + selectedOption + "</p>" + "<p><b>Delivery Type:</b> " + selectedDelType + "</p>" + output;

    $("#deliveryday").val(selectedOption);
    $("#deliverytype").val(selectedDelType);
    $("#completepackagedayreview").html(output);
    $("#completepackagedaybuilder").fadeOut();
    $("#completepackagedayreview").fadeIn();
    $("#cmb-add-to-cart").fadeIn();
    $("#revieworder").fadeOut(); 
    $(".hide-on-review").fadeOut();
}

function showcalc() {
  $("#mealcalc").fadeIn();
}

function filtercompletemealpackages(userweightfilter = 0) {

  $(".bestfit").removeClass("bestfit");
  if (userweightfilter == 0) {
    alert("Please fill out the fields in the calculator so we can recommend our most suitable packages.")
  }

    let n = [1500, 1800, 2000, 2200, 2500, 3000]; // Calorie Array Matching our packages
      
    let sortedArray = n.sort((a, b) => Math.abs(a - userweightfilter) - Math.abs(b - userweightfilter));

    //Select the top two packages from the array as closest match to the input calories
    console.log(sortedArray);

    // 25 Sept 2026: wording fix, "your require" is now "you need". Note: the plans page template defines its own
    // filtercompletemealpackages() after this file loads, so this version is normally not the one that runs.
    document.getElementById("calcrecommends").innerHTML = "<h1>Based on what you told us we estimate you need <b>" +userweightfilter + "</b> kcals per day to reach your goal.</p>";
    document.getElementById("calcrecommends").innerHTML += "<p>We recommend our <b>"+sortedArray[0]+"</b> or <b>" + sortedArray[1] + "</b> Complete Meal Packages.</p>"; 
    $("#"+sortedArray[0]).addClass("bestfit");
    $("#"+sortedArray[1]).addClass("bestfit");
    $("#mealcalc").fadeOut();
}

function isNumber(evt) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode; 
    // 25 Sept 2026: also allow a decimal point (46), so 72.5 kg or 180.5 cm can be typed
    if (charCode > 31 && charCode !== 46 && (charCode < 48 || charCode > 57)) {
        return false;
    }
    return true; 
}

function bmrMifflinStJeor(age, gender, height, weight) {
    let bmr;
    if (gender.toLowerCase() === "male") {
        bmr = 10 * weight + 6.25 * height - 5 * age + 5;
    } else if (gender.toLowerCase() === "female") {
        bmr = 10 * weight + 6.25 * height - 5 * age - 161;
    } else {
        throw new Error("Invalid gender. Please use 'male' or 'female'.");
    }
    return bmr;
}

function tdeeCalculator(age, gender, height, weight, activityLevel) {
    const activityMultipliers = {
        bmr: 1.0,
        sedentary: 1.2,
        light: 1.375,
        moderate: 1.55,
        active: 1.725,
        very_active: 1.9,
        extra_active: 2.2,
    };

    const bmr = bmrMifflinStJeor(age, gender, height, weight);
    const tdee = bmr * activityMultipliers[activityLevel.toLowerCase()];

    const weightChangeCalories = {
        "-1": -7700,
        "-0.75": -5775,
        "-0.5": -3850,
        "-0.25": -1925,
        "0": 0,
        "0.25": 1925,
        "0.5": 3850,
        "0.75": 5775,
        "1": 7700,
    };

    const results = {};
        var activityTdee = tdee; //bmr * activityMultipliers[activity];

        for (const change in weightChangeCalories) {
            let adjustedTdee = activityTdee + weightChangeCalories[change] / 7;
            if (change < 0) {
                adjustedTdee = Math.max(adjustedTdee, bmr);
            }
            results[change] = Math.round(adjustedTdee);
        }

    return results;
}

function calculateuserdata() {
    document.getElementById("bmr").innerHTML = "";
    var age = document.getElementById('age').value;
    var gender = document.querySelector('input[name="gender"]:checked').value
    var height = document.getElementById('height').value; // In centimeters
    var weight = document.getElementById('weight').value; // In kilograms
    var activityLevel = document.getElementById('activity').value;
    var goal = document.getElementById('goal').value;

    if(height > 0 && weight > 0){

    const tdeeResults = tdeeCalculator(age, gender, height, weight, activityLevel);
    const bmrResults = tdeeCalculator(age, gender, height, weight, "bmr");
   
        document.getElementById("bmr").innerHTML = "<p style='text-align:center;'><strong>Weight Maintenance Value:</strong> "+tdeeResults["0"]+" kcals / Basal Metabolic Rate (BMR): "+bmrResults["0"]+"</p>";
        if(activityLevel != "bmr") {
            document.getElementById("bmr").innerHTML += "<p><strong>Energy intake to lose weight:</strong><br/>";
            if(bmrResults["0"] < tdeeResults["-0.25"]) {
                document.getElementById("bmr").innerHTML += "<span style='min-width: 140px; display: inline-block;'>Mild Weight Loss:</span> -0.25 kilos per week <b>"+tdeeResults["-0.25"]+" kcals</b><br/>";
            }
            if(bmrResults["0"] < tdeeResults["-0.5"]) {
                document.getElementById("bmr").innerHTML += "<span style='min-width: 140px; display: inline-block;'>Weight Loss:</span> -0.5 kilos per week <b>"+tdeeResults["-0.5"]+" kcals</b><br/>";
            }
            if(bmrResults["0"] < tdeeResults["-0.75"]) {
                document.getElementById("bmr").innerHTML += "<span style='min-width: 140px; display: inline-block;'>Quick Weight Loss:</span> -0.75 kilos per week <b>"+tdeeResults["-0.75"]+" kcals</b><br/>";
            }
            if(bmrResults["0"] < tdeeResults["-1"]) {
                document.getElementById("bmr").innerHTML += "<span style='min-width: 140px; display: inline-block;'>Extreme Weight Loss:</span> -1 kilos per week <b>"+tdeeResults["-1"]+" kcals</b><br/>";
            }
            if(bmrResults["0"] >= tdeeResults["-1"]) {
                document.getElementById("bmr").innerHTML += "<br/>Please consult with a doctor when losing more weight as it requires that you consume less than the BMR recommendation.";
            }

            document.getElementById("bmr").innerHTML += "</p>";

            document.getElementById("bmr").innerHTML += "<p><strong>Energy intake to gain weight:</strong><br/>";
            if(bmrResults["0"] < tdeeResults["0.25"]) {
                document.getElementById("bmr").innerHTML += "<span style='min-width: 140px; display: inline-block;'>Mild Weight Gain:</span> +0.25 kilos per week <i>"+tdeeResults["0.25"]+" kcals</i><br/>";
            }
            if(bmrResults["0"] < tdeeResults["0.5"]) {
                document.getElementById("bmr").innerHTML += "<span style='min-width: 140px; display: inline-block;'>Weight Gain:</span> +0.5 kilos per week <i>"+tdeeResults["0.5"]+" kcals</i><br/>";
            }
            if(bmrResults["0"] < tdeeResults["0.75"]) {
                document.getElementById("bmr").innerHTML += "<span style='min-width: 140px; display: inline-block;'>Fast Weight Gain:</span> +0.75 kilos per week <i>"+tdeeResults["0.75"]+" kcals</i><br/>";
            }
            if(bmrResults["0"] < tdeeResults["1"]) {
                document.getElementById("bmr").innerHTML += "<span style='min-width: 140px; display: inline-block;'>Extreme Weight Gain:</span> +1 kilos per week <i>"+tdeeResults["1"]+" kcals</i><br/>";
            }
            document.getElementById("bmr").innerHTML += "</p>";
        }

      switch (goal) {
        case "l":
              filtercompletemealpackages(tdeeResults["-0.5"])
          break;
        case "m":
             filtercompletemealpackages(tdeeResults["0"])
          break;
        case "g":
             filtercompletemealpackages(tdeeResults["0.5"])
          break;
      }         

      //
   // }
    } else {
        document.getElementById("bmr").innerHTML = "<p>Please enter a weight and height</p>";
    }
}
